import { render, staticRenderFns } from "./CommonInformationStep.vue?vue&type=template&id=0abbb4fa"
import script from "./CommonInformationStep.vue?vue&type=script&lang=ts"
export * from "./CommonInformationStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports